import "../scss/app.scss"; // Importing SCSS file

class StarGenerator {
  constructor(elementsToRunStarsOn = null) {
    // Initialize an array to store the stars
    this.stars = [];
    // Set the time-to-live for stars (in milliseconds)
    this.time_to_live = 2000;
    // Initialize mouse position variables
    this.x = 0;
    this.y = 0;
    // Track the previous mouse position
    this.prevX = 0;
    this.prevY = 0;
    // Initialize variables to track the mouse movement
    this.diffX = 0;
    this.diffY = 0;
    // Elements on which stars animation should run (optional)
    this.elementsToRunStarsOn = elementsToRunStarsOn;
    // Interval ID for controlling star animation
    this.starsInterval;
    // Default star dimensions
    this.starFreezeCounter = 0;
    this.freezeInterval;

    this.height = moxcarChromaSettings.height;
    this.width = moxcarChromaSettings.width;
    this.animateStarsTime = moxcarChromaSettings.animateStarsTime;
    this.updateStarsTime = moxcarChromaSettings.updateStarsTime;
 
   
  }

  createStar(fill, opacity, top, left) {
    // Get star dimensions
    let width = this.width;
    let height = this.height;
    // Create an SVG element
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", width);
    svg.setAttribute("height", height);

    //   zIndex as big as possible
    svg.style.zIndex = 9999999999;

    // Calculate outer and inner radii, number of points, and rotation for the star shape
    const outerRadius = Math.min(width, height) / 2;
    const innerRadius = 0.4 * outerRadius;
    const numPoints = 5;
    const rotation = Math.PI / 10; // Adjust this value for rotation

    let points = "";

    // Generate the points for the star shape
    for (let i = 0; i < numPoints * 2; i++) {
      const radius = i % 2 === 0 ? outerRadius : innerRadius;
      const angle = (i * Math.PI) / numPoints - rotation;
      const x = width / 2 + radius * Math.cos(angle);
      const y = height / 2 + radius * Math.sin(angle);

      points += `${x},${y} `;
    }

    // Create a polygon element and set its points, fill, and opacity
    const polygon = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "polygon"
    );
    polygon.setAttribute("points", points.trim());
    svg.appendChild(polygon);

    polygon.setAttribute("fill", fill);
    polygon.setAttribute("fill-opacity", opacity);

    // Set the absolute position of the SVG element
    svg.style.position = "absolute";
    svg.style.top = top + "px";
    svg.style.left = left + "px";

    // Return a star object with properties
    return {
      svg,
      polygon,
      top,
      left,
      opacity,
      width,
      height,
      time_to_live: this.time_to_live,
    };
  }

  generateRandomColor() {
    // Generate a random RGB color
    return `rgb(${Math.random() * 256},${Math.random() * 256},${
      Math.random() * 256
    })`;
  }

  animateStars() {
    // Calculate the difference between the current and previous mouse position
    this.diffX = this.x - this.prevX;
    this.diffY = this.y - this.prevY;

    // If the mouse is not moving, set a timeout to call the function again
    if (this.diffX == 0 && this.diffY == 0) {
      setTimeout(() => this.animateStars(), 10);
      return;
    }

    // Generate a random color for the star
    let fillColor = "#c8a875";
    let opacity = 1;

    // Create a star and append it to the body
    let star = this.createStar(fillColor, opacity, this.y, this.x);
    document.body.appendChild(star.svg);
    this.stars.push(star);

    // Update the previous mouse position
    this.prevX = this.x;
    this.prevY = this.y;

    // Call the animation function again basedon the animation time
    this.starsInterval = setTimeout(
      () => this.animateStars(),
      this.animateStarsTime
    );
  }

  updateStars() {
    for (let i = 0; i < this.stars.length; i++) {
      let star = this.stars[i];
      const gravity = 0.5 + Math.random() * 2;

      // Apply gravity by incrementing the top position
      star.top += 0.5 * gravity;

      // Apply subtle wind force in a random direction
      star.left += Math.random() * 2 - 1;

      // Update opacity and position
      star.time_to_live -= 15;
      star.opacity -= 0.01;
      star.svg.style.opacity = star.opacity;
      star.svg.style.top = star.top + "px";
      star.svg.style.left = star.left + "px";

      // Remove stars that have reached the bottom or faded out
      if (star.time_to_live <= 0) {
        star.svg.remove();
        this.stars.splice(i, 1);
      }
    }
    // Call the update function again based on the update time
    setTimeout(() => this.updateStars(), this.updateStarsTime);
  }

  isDescendantOfBlackListedElement(element, blackListedTags) {
    if (!element) {
      return false;
    }

    // Check if the current element is in the blacklist
    if (blackListedTags.includes(element.tagName)) {
      return true;
    }

    // Check if the parent element is not the same as the current element
    if (element.parentElement !== element) {
      // Recursively check the parent element
      return this.isDescendantOfBlackListedElement(
        element.parentElement,
        blackListedTags
      );
    }

    return false;
  }

  setMousePosition(e, x, y) {
    if (this.starFreezeCounter > 0) {
      return;
    }
    // check if the freeze counter is bigger than 0

    // Set the current mouse position offset
    this.x = x;
    this.y = y;

    // Get the element under the mouse pointer
    let currentElement =  e.target;
    let currentElementClass = currentElement?.classList;

    // Define a blacklist of tag names
    const blackListedTags = ["A", "NAV", "UL", "LI", "OL", "HEADER"];

   
    

    // Check if the current element or its ancestors are in the blacklist
    let isBlackListedElement = this.isDescendantOfBlackListedElement(
      currentElement,
      blackListedTags
    );

    // Check if stars animation should run on this element or if no specific element is specified
    if (
      currentElementClass?.contains(this.elementsToRunStarsOn) ||
      !this.elementsToRunStarsOn
    ) {
      if (!isBlackListedElement) {
        this.animateStars();
      } else {
        // If the element is in the blacklist, clear the animation interval to allow clicking
        clearTimeout(this.starsInterval);
        // delete the stars
        // this.stars.reverse.forEach((star) => {
        //   star.svg.remove();
        // });
        // this.stars = [];
        //  set a freeze on the stars to 3000
        this.starFreezeCounter = 1000;
        // set the freeze interval to 1000
        this.freezeInterval = setInterval(
          () => this.freezeReductionBySecond(),
          1000
        );
      }
    } else {
      // If not, clear the animation interval
      clearTimeout(this.starsInterval);
    }
  }

  freezeReductionBySecond() {
    // decrement the freeze counter by 1,000
    this.starFreezeCounter -= 1000;

    
    // if the freeze counter is 0
    if (this.starFreezeCounter <= 0) {
      // clear the freeze interval
      clearInterval(this.freezeInterval);
    }
  }
}

// Initialize and start animation
const starGenerator = new StarGenerator();
starGenerator.animateStars();
starGenerator.updateStars();

// Update mouse position
document.onmousemove = function (e) {
  starGenerator.setMousePosition(e, e.pageX, e.pageY);
};

document.addEventListener('DOMContentLoaded' , function() {

  function hold_sidebar_position_once_footer_is_visible() {
    let about_sidebar = document.getElementById('about-sidebar');
    let site_footer = document.querySelector('footer');
    let sidebar_coordinates = {
      top: about_sidebar.offsetTop,
      left: about_sidebar.offsetLeft,
      bottom: about_sidebar.offsetTop + about_sidebar.offsetHeight,
      right: about_sidebar.offsetLeft + about_sidebar.offsetWidth,
    };
  
    let site_footer_top_position = site_footer.offsetTop - 700;
  
    // Initial sidebar position
    about_sidebar.style.position = 'fixed';
    about_sidebar.style.zIndex = 9999;
  
    window.addEventListener('scroll', function () {
      // Calculate the current scroll position
      let scrollY = window.scrollY || window.pageYOffset;
  
       console.log(scrollY >  site_footer_top_position, 'scroll y');
  
      // Check if the sidebar is above the footer
      if (scrollY > site_footer_top_position) {
            about_sidebar.style.position = 'fixed';
            about_sidebar.style.top = '122px';
            // transition smooth
            about_sidebar.style.transition = 'top 0.5s ease-in-out';
      } else {
        about_sidebar.style.top = '250px';
        about_sidebar.style.transition = 'top 0.5s ease-in-out';
      }
    });
  }
  
  // Call the function when the DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    hold_sidebar_position_once_footer_is_visible();
  });
  

// Call the function to initialize the behavior
hold_sidebar_position_once_footer_is_visible();

});